<template>
    <div>
        <transition name="fade" mode="out-in" v-if="permisos['abonos.vender']">
            <div key="1" v-if="paso == 1" id="paso-1">
                <PasoUnoComponent
                    v-on:goTo="finalizarPasoUno"
                    :precios="precios"
                    :soloCambiarZona="solo_cambiar_zona"
                    @setZonas="setZonas"
                />
            </div>
            <div key="2" v-if="paso == 2" id="paso-2">
                <b-row>
                    <b-col cols="12" class="text-right mb-3">
                        <Button
                            @click="iniciarCambioZona"
                        >
                            Cambiar zona
                        </Button>
                    </b-col>
                </b-row>
        
                <PasoDosComponent
                    :key="reload"
                    :abono_seleccionado="abono_seleccionado"
                    :datos_compradores="datos_compradores"
                    :zona="zona_seleccionada"
                    :zonas="zonas"
                    v-on:goTo="finalizarPasoDos"
                    v-on:resetDatos="resetDatos"
                    @setSessionButacaData="setSessionButacaData"
                    @setSessionId="(sessionId) => { session_id = sessionId }"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" id="paso-3">
                <PasoTresComponent 
                    :datos_compradores="datos_compradores" 
                    v-on:goTo="finalizarPasoTres" 
                    :precios="precios" 
                    :zona="zona_seleccionada" 
                    :disabled="paso >= 4"
                    :session_id="session_id"
                    @actualizar="datos => datos_compradores = datos"
                    @volver="borrarSesion" 
                    @solicitarPlazos="aplicarPlazos"
                    :session_butaca_data="session_butaca_data"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" id="paso-4">
                <PasoCuatroComponent
                    ref="pasoCuatro"
                    :datos_compradores.sync="datos_compradores"
                    :datos_compra="datos_compra"
                    :session_id="session_id"
                    @reiniciar="reiniciar"
                    @procesar="procesarCompra"
                    :procesando="procesando"
                    @volver-paso-anterior="volverPaso3"
                    @update:datos_compradores="enviarDatosCompradores"
                />
            </div>
        </transition>
    </div>
</template>

<script>
    import PasoUnoComponent from '@/components/backend/stepper/abonos/con-recinto/PasoUnoComponent';
    import PasoDosComponent from '@/components/backend/stepper/abonos/con-recinto/PasoDosComponent';
    import PasoTresComponent from '@/components/backend/stepper/abonos/con-recinto/PasoTresComponent';
    import PasoCuatroComponent from '@/components/backend/stepper/abonos/common/PasoCuatroComponent';

    export default {
        data() {
            return {
                paso: 1,
                zona_seleccionada: null,
                zonas: null,
                datos_compradores: [],
                precios: null,
                datos_compra: null,
                abono_seleccionado: null,
                reload: 1,
                session_butaca_data: null,
                session_id: null,
                procesando: false,
                solo_cambiar_zona: false
            }
        },
        methods: {
            finalizarPasoUno(paso, zona, abonado) {
                if(zona) {
                    this.zona_seleccionada = zona;

                    if(abonado) {
                        this.abono_seleccionado = abonado;
                        this.$router.push({name: 'back.abonos.index', query: {zona: zona.id, n_abonado_antiguo: abonado.n_abonado_antiguo}});
                    }

                    if (this.solo_cambiar_zona) {
                        this.solo_cambiar_zona = false;
                        this.paso = 2;
                        this.reload += 1;
                        this.datos_compradores = [];

                        this.$nextTick(function() {
                            this.scrollTo('#paso-2');
                        });
                        return;
                    }
                }
                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoDos(paso, datos) {
                if(datos) {
                    this.datos_compradores = Object.assign({}, datos);
                }

                if (this.session_butaca_data) {
                    Object.values(this.datos_compradores).forEach(comprador => {
                        const butaca = this.session_butaca_data.find(b => {
                            if(comprador.asiento) {
                                return b.seat == comprador.asiento.asiento && b.row == comprador.asiento.fila;
                            } else if (comprador.plaza) {
                                return b.plaza_id == comprador.plaza.id;
                            }
                        });
                        
                        if (butaca) {
                            comprador.lista_abonado_sesion_id = butaca.id;
                        }
                    });
                }

                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoTres(paso, datos_compra) {
                if (datos_compra.metodo_pago && !Array.isArray(datos_compra.metodo_pago)) {
                    datos_compra.metodo_pago = [datos_compra.metodo_pago];
                }
                this.datos_compra = datos_compra;
                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            getPrecios() {
                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.precios = res.data;

                    for (var i in this.precios) {
                        this.precios[i].unidades = 0;
                    }
                });
            },
            procesarCompra(referido_id) {
                this.procesando = true;
                if (this.compraConPlazos) {
                    Object.values(this.datos_compradores).forEach(comprador => {
                        delete comprador.metodo_pago;
                    });
                }

                const params = {

                    metodo_pago: Array.isArray(this.datos_compra.metodo_pago) 
                        ? this.datos_compra.metodo_pago.map(mp => {
                            const obj = { id: mp.id };
                            if (mp.importe !== undefined && mp.importe !== null && mp.importe !== '') {
                                obj.importe = mp.importe;
                            }
                            obj.lista_abonado_sesion_id = mp.lista_abonado_sesion_id;
                            return obj;
                        })
                        : [{ id: this.datos_compra.metodo_pago.id}],

                    session_id: this.session_id,
                    lista_id: this.lista_id

                };

                if (referido_id) {
                    params.referido_id = referido_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.alta'), params).then(res => {
                    this.$refs.pasoCuatro.compra_finalizada = true;
                    this.$refs.pasoCuatro.urls_imprimir = res.data.urls_imprimir;
                    this.$refs.pasoCuatro.url_factura = res.data.url_factura;
                    this.$refs.pasoCuatro.error = null;
                }).catch(error => {
                    this.$refs.pasoCuatro.error = error.response.data.message;
                }).finally(() => {
                    this.procesando = false;
                });
            },
            reiniciar() {
                this.paso = 1;
                this.zona_seleccionada = null;
                this.datos_compradores = [];
                this.datos_compra = null;
                this.solo_cambiar_zona = false;
                this.borrarSesion();
                this.$router.replace({name: 'back.abonos.index', query: {}});
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            goTo(paso) {
                if(paso < this.paso) {
                    if(paso == 1) {
                        if (!this.solo_cambiar_zona) {
                            this.datos_compradores = [];
                        }
                        this.paso = paso;
                    }
                }
            },
            iniciarCambioZona() {
                this.solo_cambiar_zona = true;
                this.paso = 1;
                this.$nextTick(function() {
                    this.scrollTo('#paso-1');
                });
            },
            resetDatos(new_zona) {
                this.reload += 1;
                this.datos_compradores = [];
                this.zona_seleccionada = new_zona;
            },
            setZonas(zonas) {
                this.zonas = zonas;
            },
            aplicarPlazos(datos) {
                this.datos_compradores = datos;
            },
            borrarSesion() {
                this.$emit('borrarSesion', true, this.session_id);
            },
            setSessionButacaData(data) {
                this.session_butaca_data = data;
            },
            enviarDatosCompradores() {
                const params = {
                    "lista_id": this.$store.getters.getListaId,
                    "session_id": this.session_id,
                    "datos_compradores": 
                        Object.values(this.datos_compradores).map((comprador, index) => {     
                            let sessionButacaId;
                            if (this.session_butaca_data ) {
                                sessionButacaId = this.session_butaca_data[index].id;
                            }

                            let abono = {
                                "nombre": comprador.nombre,
                                "apellidos": comprador.apellidos,
                                "email": comprador.email,
                                "genero_id": comprador.genero_id,
                                "dni": comprador.dni,
                                "telefono": comprador.telefono,
                                "fecha_nacimiento": comprador.fecha_nacimiento,
                                "pais": comprador.pais,
                                "provincia": comprador.provincia,
                                "localidad": comprador.localidad,
                                "domicilio": comprador.domicilio,
                                "penista": comprador.penista,
                                "cp": comprador.cp,
                                "es_nuevo": comprador.es_nuevo,
                                "precio": {
                                    "id": comprador.precio.id,
                                    "precio": comprador.precio.precio
                                },
                                "area": {
                                    "id": comprador.area.id,
                                    "descripcion": comprador.area.descripcion,
                                    "precio": comprador.area.precio,
                                    "renovacion": comprador.area.renovacion,
                                    "privacidad": comprador.privacidad,
                                    "condiciones": comprador.condiciones,
                                    "comunicaciones": comprador.comunicaciones
                                },
                                "plazos": comprador.plazos ? comprador.plazos : false,
                                "plazos_pendientes": comprador.plazos_pendientes ? comprador.plazos_pendientes : [],
                                "descuento_aplicado": comprador.descuento_aplicado ? comprador.descuento_aplicado : null,
                                "descuento_integro": comprador.descuento_integro ? comprador.descuento_integro : null,
                                "lista_abonado_session_id": sessionButacaId,
                                "n_abonado_antiguo": comprador.n_abonado_antiguo ? comprador.n_abonado_antiguo : null,
                                'descuento_monedero': comprador.descuento_monedero ? comprador.descuento_monedero : null,
                            }

                            if (comprador.plaza && Object.keys(comprador.plaza).length) {
                                abono.plaza = comprador.plaza;
                            } else {
                                abono.asiento = comprador.asiento;
                            }

                            return abono;
                        })
                }
                
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.guardar-datos-comprador'), params).catch(error => {
                    this.$toast.error('Error al enviar los datos de los compradores');
                });
            },
            volverPaso3() {
                this.paso = 3;
            }
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos;
            },
            lista_id() {
                return this.$store.getters.getListaId;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            compraConPlazos() {
                const datos = Object.values(this.datos_compradores);
                return this.teatro.permitir_plazos_abonados && datos.every(abono => abono.area && abono.area.activar_pago_plazos);
            }
        },
        created() {
            this.getPrecios();
        },
        components: {
            PasoUnoComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent
        }
    }
</script>